export default __webpack_public_path__ + "static/media/send.d6b43832.svg";